import React, { useState, useEffect, useRef } from 'react';
import { APIProvider, useMapsLibrary } from '@vis.gl/react-google-maps';

const API_KEY = import.meta.env.VITE_GOOGLE_MAP_API_KEY;

const LocationInputbox = ({
  title = 'Dirección de residencia',
  placeholder = 'Carrera 7, Bogotá, Cundinamarca, Colombia',
  address,
  setAddress,
}) => {
  const handlePlaceSelect = (place) => {
    console.log('Selected place:', place);
    // setAddress(place.formatted_address);
  };

  return (
    <APIProvider
      apiKey={API_KEY}
      solutionChannel="GMP_devsite_samples_v3_rgmautocomplete"
    >
      <PlaceAutocomplete
        onPlaceSelect={handlePlaceSelect}
        title={title}
        placeholder={placeholder}
        address={address}
        setAddress={setAddress}
      />
    </APIProvider>
  );
};

const PlaceAutocomplete = ({
  onPlaceSelect,
  title,
  placeholder,
  address,
  setAddress,
}) => {
  const [placeAutocomplete, setPlaceAutocomplete] = useState(null);
  const inputRef = useRef(null);
  const places = useMapsLibrary('places');

  useEffect(() => {
    if (!places || !inputRef.current) return;

    const options = {
      fields: ['geometry', 'name', 'formatted_address'],
    };

    const autocomplete = new places.Autocomplete(inputRef.current, options);
    setPlaceAutocomplete(autocomplete);
  }, [places]);

  useEffect(() => {
    if (!placeAutocomplete) return;

    placeAutocomplete.addListener('place_changed', () => {
      onPlaceSelect(placeAutocomplete.getPlace());
    });
  }, [placeAutocomplete, onPlaceSelect]);

  return (
    <div className="w-full space-y-1">
      <div
        className={`font-[poppins] text-xs text-[#424242] font-normal leading-[20px] tracking-[0%]`}
      >
        {title}
      </div>
      <input
        ref={inputRef}
        value={address}
        onChange={(e) => setAddress(e.target.value)} // track user input
        placeholder={placeholder}
        className={`w-full font-[poppins] text-sm placeholder-[#A4A7AE] text-[#414651] font-normal focus:outline-none focus:border-[#414651] border border-[#C2C2C2] bg-[#FDFDFD] py-2 px-3 rounded-[10px]`}
      />
    </div>
  );
};

export default LocationInputbox;
